"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const fov_errors_1 = require("./fov-errors");
const fov_nodes_1 = require("./fov-nodes");
class FovBuilder {
    constructor(root = fov_nodes_1.FovNodes.blankGroup()) {
        this.root = root;
        this.root = root || fov_nodes_1.FovNodes.blankGroup();
    }
    and(...fovNodes) {
        const andGroup = fov_nodes_1.FovNodes.andGroup();
        andGroup.children = andGroup.children.concat(this.root, fovNodes);
        return new FovBuilder(andGroup);
    }
    or(...fovNodes) {
        const orGroup = fov_nodes_1.FovNodes.orGroup();
        orGroup.children = orGroup.children.concat(this.root, fovNodes);
        return new FovBuilder(orGroup);
    }
    not(fovNode) {
        const not = fov_nodes_1.FovNodes.not(fovNode);
        return new FovBuilder(not);
    }
    get(index) {
        if (fov_nodes_1.FovNodes.isGroup(this.root)) {
            const length = this.root.children.length;
            if (length <= index) {
                throw new fov_errors_1.FovIndexOutOfBoundsError(index, length);
            }
            return this.root.children[index];
        }
        else {
            throw new fov_errors_1.FovError('FOV.INDEX_CALL_ON_FILTER', 'Cannot call index on filter node');
        }
    }
    toArray() {
        return [...this.traverse()];
    }
    conditions() {
        return [...this.traverseNode(this.root)].filter(node => {
            return fov_nodes_1.FovNodes.isFilter(node);
        });
    }
    filter(...fieldTypes) {
        return [...this.traverseNode(this.root)].filter(node => {
            if (fov_nodes_1.FovNodes.isFilter(node)) {
                return fieldTypes.includes(node.field);
            }
            else {
                return false;
            }
        });
    }
    slice(level = 1) {
        let childrenToSlice = [this.root];
        for (let i = 0; i < level; i++) {
            childrenToSlice = childrenToSlice
                .map(node => this.sliceNode(node))
                .reduce((acc, el) => {
                acc.push(...el);
                return acc;
            }, []);
        }
        return childrenToSlice;
    }
    contains(fieldType) {
        const traverseResult = [...this.traverseNode(this.root)];
        return (traverseResult.filter(element => (fov_nodes_1.FovNodes.isFilter(element) ? element.field === fieldType : false)).length > 0);
    }
    find(fieldType, value) {
        return this.findAll(fieldType, value)[0];
    }
    findAll(fieldType, value) {
        return [...this.traverseNode(this.root)].filter(node => {
            if (fov_nodes_1.FovNodes.isFilter(node)) {
                return node.field === fieldType && isEqual_1.default(node.value, value);
            }
            else {
                return false;
            }
        });
    }
    traverse() {
        return this.traverseNode(this.root);
    }
    get value() {
        return this.root;
    }
    build() {
        return JSON.parse(JSON.stringify(this.root));
    }
    mutate(matcher, callback) {
        const traverseResult = [...this.traverseNode(this.root)];
        let parentGroup;
        const stackGroup = [traverseResult[0]];
        for (let index = 1; index < traverseResult.length; index++) {
            if (fov_nodes_1.FovNodes.isGroup(traverseResult[index])) {
                const subGroup = [...this.traverseNode(traverseResult[index])];
                subGroup.forEach(el => {
                    if (matcher(el)) {
                        stackGroup.push(...subGroup);
                    }
                });
            }
        }
        stackGroup.forEach(node => {
            if (matcher(node)) {
                return parentGroup;
            }
            if (fov_nodes_1.FovNodes.isGroup(node)) {
                parentGroup = node;
            }
        });
        if (parentGroup) {
            parentGroup.children.forEach((node, index) => {
                if (matcher(node)) {
                    callback(parentGroup, node, index);
                }
            });
        }
    }
    sliceNode(node) {
        if (fov_nodes_1.FovNodes.isGroup(node)) {
            return node.children;
        }
        else if (fov_nodes_1.FovNodes.isNotGroup(node)) {
            return [node.child];
        }
        else {
            return [];
        }
    }
    *traverseNode(node) {
        yield node;
        if (fov_nodes_1.FovNodes.isGroup(node)) {
            for (const child of node.children) {
                if (fov_nodes_1.FovNodes.isGroup(child)) {
                    const traversed = [...this.traverseNode(child)];
                    for (const el of traversed) {
                        yield el;
                    }
                }
                else {
                    yield child;
                }
            }
        }
        else if (fov_nodes_1.FovNodes.isNotGroup(node)) {
            const child = node.child;
            if (fov_nodes_1.FovNodes.isGroup(child)) {
                const traversed = [...this.traverseNode(child)];
                for (const el of traversed) {
                    yield el;
                }
            }
            else {
                yield child;
            }
        }
    }
}
exports.FovBuilder = FovBuilder;
//# sourceMappingURL=fov-builder.js.map